var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section-why-vivense',{ref:"whyVivense"}),_c('section-how-it-works',{ref:"howItWorks"}),_c('section-what-can-i-sell',{ref:"whatCanISell"}),_c('section-faq',{ref:"faq"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }